import type { ProgramCandidate } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockCandidates: ProgramCandidate[] = [
  {
    id: 'cand-1',
    currentState: 'Verified',
    organisation: { id: 'org-1', name: 'Mock Org', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-a',
    currentState: 'Verified',
    organisation: { id: 'org-a', name: 'Org A', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-b',
    currentState: 'Verified',
    organisation: { id: 'org-b', name: 'Org B', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-r',
    currentState: 'Rejected',
    organisation: { id: 'org-r', name: 'Org R', countryCode: 'USA' },
    rejectionReason: 'Bad docs',
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-f',
    currentState: 'Finalists',
    organisation: { id: 'org-f', name: 'Org F', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-p',
    currentState: 'Donation Paid',
    organisation: { id: 'org-p', name: 'Org P', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: null
  },
  {
    id: 'cand-d',
    currentState: 'Verified',
    organisation: { id: 'org-d', name: 'Org D', countryCode: 'USA' },
    createdAt: new Date('2025-01-15T10:23:45Z'),
    deletedAt: new Date('2025-01-15T10:23:45Z')
  }
]

export const mockCandidateDetailFields = {
  orgContactEmail: 'contact@org.org',
  orgContactFirstName: 'Alice',
  orgContactLastName: 'King',
  orgContactAccountId: 'acc_123'
}
